/**
 * Route path constants
 */

export const ROUTES = {
  HOME: "/",
  LANDING: "/landing/",
  MY_LIBRARY: "/my-library/",
  MY_LIBRARY_UPLOADS: "/my-library/uploads/",
  MY_LIBRARY_EXPORTS: "/my-library/exports/",
  MY_LIBRARY_CALENDAR: "/my-library/calendar/",
  MY_LIBRARY_MEETINGS: "/my-library/meetings/",
  MY_LIBRARY_SEARCH: "/my-library/search/",
  MY_LIBRARY_ARTISTIC: "/my-library/artistic/",
  CREATE_VIDEO: "/create-video/",
  ARCHIVE: "/archive/",
  // The curated clip shortlist ("content factory"): ~20 clips picked by a recipe, to
  // browse and tick. The router is an exact-match table with no path params, so the
  // transcript rides in a query string: /reel/?t=<id>.
  REEL: "/reel/",
  // Artistic edits (beta): the staff queue of requests (the page itself checks staff).
  STUDIO: "/studio/",
  LOGOUT: "/logout/",
  NOT_FOUND: "/404/",
  SUBSCRIPTION: "/subscription/",
  SUBSCRIPTION_SUCCESS: "/subscription/success/",
  SUBSCRIPTION_CANCEL: "/subscription/cancel/",
  SUBSCRIPTION_MANAGE: "/subscription/manage/",
  // Public, shareable URL for the plans page. The Premiere panel points people here when
  // they hit a plan limit (api.js: "Subscribe at <origin>/pricing"), so this MUST exist —
  // it used to 404, which killed the upgrade moment.
  PRICING: "/pricing/",
  // Support. Linked from the footer, the payment success page and the panel.
  CONTACT: "/contact/",
  // The public Premiere-plugin marketing page (layout S). It has existed as a route in
  // router.jsx since we started sharing it, but was never in this table — so nothing in the
  // app could link to it without hardcoding the string.
  PLUGIN: "/plugin",
  // The flagship page (layout R) on a PUBLIC route. Marketing pages must link here, never to
  // HOME — HOME is auth-gated, so a logged-out visitor clicking "Home" on /plugin was being
  // thrown into the login wall.
  FLAGSHIP: "/flagship",
  // Home layouts W / X / Y (October 2026), public for feedback, and the store link behind the QR code.
  LAYOUT_W: "/w",
  LAYOUT_X: "/x",
  LAYOUT_Y: "/y",
  LAYOUT_Z: "/z",
  GET_APP: "/get",
  // Gated download page for the Premiere Pro panel (.zxp). The page is public so people
  // can read what it is; the FILE itself is served only to a logged-in account by the
  // backend (see plugin_download in emo_users/views.py).
  PLUGIN_DOWNLOAD: "/plugin-download/",
  // The phone app's flows, reachable on the web for phone-browser testing. Inside the
  // Capacitor shell the same screens are the root of the app (router.jsx, isNativeApp).
  MOBILE: "/m",
  // The public page about the Android app: what it does, the download, the install taps.
  // Linked from the flagship nav and phone section; the app sends an out-of-date phone here.
  APP: "/app",
  // Public legal pages. Google Play requires a privacy-policy URL that opens without a
  // login, and we take other people's email and video, so these are not optional.
  PRIVACY: "/privacy",
  TERMS: "/terms",
  AI_CONNECTOR: "/ai",
  DELETE_ACCOUNT: "/delete-account",
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
